import React, { useState } from "react";
import "./Main.css";
import MainHeader from "../Header/MainHeader";
import Feedback from "../FeedbackPannel/Feedback";
import Enquiry from "../ContactForm/Enquiry";
import Login from "../AdminPannel/Login";

export default function Main() {
  const [activeTab, setActiveTab] = useState("Enquiry");

  return (
    <div className="PageBackground">
      <div className="MainContainer">
        <MainHeader active={activeTab} setActive={setActiveTab} />

        <div className="BodyContainer">
          {activeTab === "Feedback" && <Feedback />}
          {activeTab === "Enquiry" && <Enquiry />}
          {activeTab === "Admin" && <Login />}
        </div>
      </div>
    </div>
  );
}
